import * as yup from 'yup'

export const schema = (existingLengths: number[], currentLength?: number) =>
  yup.object({
    id: yup.string().optional(),
    isStandard: yup.boolean().required(),
    length: yup
      .number()
      .typeError('Length is required')
      .integer('Length must be a whole number')
      .positive('Length must be greater than zero')
      .required('Length is required')
      .test('unique-length', 'Length must be unique', value => {
        if (value == null || value === currentLength) return true
        return !existingLengths.includes(value)
      }),
    bayCount: yup
      .number()
      .typeError('Bay count is required')
      .integer('Bay count must be a whole number')
      .positive('Bay count must be greater than zero')
      .required('Bay count is required'),
  })
